export const USER_ROLES = {
  user: 0,
  admin: 1,
  prescriber: 3,
  non_prescriber: 4,
  non_registered_prescriber: 6,
};

export const STATIC_WORD = {
  treatment: {
    small: 'treatment',
    capital: 'Treatment',
    plural: 'treatments',
  }
}

export const FACES_COMMISSION_AMT = 0.2;

export const APP_COMPONENT_SIZE = {
  small: 'small',
  medium: 'medium',
  large: 'large',
  regular: 'regular',
};